import { createContext, FunctionComponent, ReactNode } from "react";
import { IDimensions } from "./chartUtils";
import "./chart.css";

type IProps = {
  dimensions: IDimensions;
  children: ReactNode;
};

const ChartContext = createContext<IDimensions | null>(null);
// export const useDimensionsContext = ():  IDimensions | null => useContext(ChartContext);

const Chart: FunctionComponent<IProps> = ({ dimensions, children }: IProps) =>
  <ChartContext.Provider value={dimensions}>
    <svg className="Chart" width={dimensions.width} height={dimensions.height}>
      <g transform={`translate(${dimensions.marginLeft}, ${dimensions.marginTop})`}>
        { children }
      </g>
    </svg>
  </ChartContext.Provider>
;

export default Chart;

